/**
 * Utility functions for PWA-related functionality
 */

/**
 * Check if the application is running in PWA mode
 * @returns {boolean} True if running in PWA mode, false otherwise
 */
export const isPwaMode = () => {
  // Check if display-mode is standalone (PWA installed on home screen)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  
  // Check for iOS standalone mode
  const isIOSStandalone = window.navigator.standalone;
  
  // Check if launched from Android app
  const isAndroidApp = document.referrer.includes('android-app://');
  
  return isStandalone || isIOSStandalone || isAndroidApp;
};

/**
 * Get the list of routes allowed in PWA mode
 * @returns {Array} Array of route names allowed in PWA mode
 */
export const getAllowedPwaRoutes = () => {
  return [
    'DietitianFormSelector',
    'SelectPage',
    'Form',
    'PromoForm',
    'MealplanEbook',
    'PromoEbookPage',
    'InvitePage'
  ];
};

/**
 * Get the default route for PWA mode based on localStorage state
 * @returns {string} The name of the default route for PWA mode
 */
export const getDefaultPwaRoute = () => {
  // Check if dietitianId exists in localStorage
  const dietitianId = localStorage.getItem('dietitianId');
  const dietitianName = localStorage.getItem('dietitianName');
  
  // If both dietitianId and dietitianName exist, redirect to select-page
  if (dietitianId && dietitianName) {
    return 'SelectPage';
  }
  
  // Otherwise, go to the dietitian form selector
  return 'DietitianFormSelector';
}; 